import { Controller } from 'stimulus';
import Chart from 'chart.js/auto';
import { hourLabels, seriesByHour } from './shared/labels';
import { currentLocale, t } from '../../javascript/lib/i18n';
import { currentTheme } from '../chart_controller/plugins/background_color_plugin';

const COLOR_BLACK = '#000';
const COLOR_GRAY = '#AAAFB5';
const COLOR_GRAY_LIGHT = '#E5E5E5';
const COLOR_GRAY_DARK = '#6A6A6A';

export default class extends Controller {
  static targets = ['canvas'];
  static values = { data: Object, url: String };

  disconnect() {
    this.chart.destroy();

    document.removeEventListener(
      'amba:theme_changed',
      this.reInitializeOnColorChange
    );
  }

  connect() {
    document.addEventListener(
      'amba:theme_changed',
      this.reInitializeOnColorChange
    );
    this.initializeChart();
  }

  reInitializeOnColorChange = () => {
    this.chart.destroy();
    this.initializeChart();
  };

  initializeChart() {
    const labels = hourLabels(currentLocale());

    this.chart = new Chart(this.canvasTarget, {
      type: 'bar',
      options: {
        interaction: {
          mode: 'index',
        },
        plugins: {
          legend: {
            labels: {
              color: this.legendLabelColor,
            },
          },
          tooltip: {
            callbacks: {
              title: (data) => {
                const label = data[0].label;
                const labelIndex = data[0].chart.data.labels.indexOf(label);
                const nextHour =
                  data[0].chart.data.labels[labelIndex + 1] || labels[0];

                return `${label} - ${nextHour}`;
              },
            },
          },
        },
        scales: {
          x: {
            steps: 1,
            beginAtZero: true,
            title: {
              display: true,
              text: t('js.charts.common.hour'),
              color: this.chartLabelColor,
            },
            grid: {
              display: true,
              color: this.gridColor,
              borderColor: this.gridColor,
            },
            ticks: {
              color: this.chartLabelColor,
            },
          },
          y: {
            title: {
              display: true,
              text: t('js.charts.common.frequency'),
              color: this.chartLabelColor,
            },
            ticks: {
              precision: 0,
              color: this.chartLabelColor,
            },
            grid: {
              display: false,
            },
          },
        },
      },
      data: {
        labels: labels,
        datasets: [
          {
            label: t('js.charts.activities.door_events'),
            backgroundColor: '#643BBA',
            datalabels: {
              display: false,
            },
            data: seriesByHour(this.dataValue.door_events),
          },
          {
            label: t('js.charts.activities.nighttime_bathroom_visits'),
            backgroundColor: '#d23dad',
            datalabels: {
              display: false,
            },
            data: seriesByHour(this.dataValue.nighttime_bathroom_visits),
          },
          {
            label: t('js.charts.activities.all_other_activity_events'),
            backgroundColor: '#08cff7',
            datalabels: {
              display: false,
            },
            data: seriesByHour(this.dataValue.other_activity_events),
          },
        ],
      },
    });
  }

  get legendLabelColor() {
    return currentTheme() === 'light' ? COLOR_BLACK : COLOR_GRAY;
  }

  get chartLabelColor() {
    return currentTheme() === 'light' ? COLOR_GRAY_DARK : COLOR_GRAY;
  }

  get gridColor() {
    return currentTheme() === 'light' ? COLOR_GRAY_LIGHT : COLOR_GRAY_DARK;
  }
}
